import React from "react";
import { useSpecialities } from "newui/features/Company/hooks/useSpecialities";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface SpecialitySelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	selectedIds?: number[];
}

export const SpecialitySelect: React.FC<SpecialitySelectProps> = ({
	label = "Specialty",
	placeholder = "Select specialties",
	selectedIds,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	...rest
}) => {
	const { values, isLoading } = useSpecialities();
	const formik = useFormikFieldState(name);

	const resolvedValue = selectedIds
		? isLoading
			? undefined
			: selectedIds
				.map((id) => values.find((s) => s.value === id))
				.filter(Boolean) as SelectOption[]
		: valueProp;

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={values as SelectOption[]}
			isLoading={isLoading}
			isMulti
			label={label}
			placeholder={placeholder}
			value={resolvedValue}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			{...rest}
		/>
	);
};
